module.exports = __webpack_public_path__ + "static/media/Upsell_Tab_Amazing@3x.5dd60a65.png";